// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../fe-workerportal/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".layout-time[data-v-0698ece4]>:not(:last-child){margin-right:.5em}", ""]);
// Exports
module.exports = exports;
